"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalThought() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const tickerItems = ["STRATEGY", "CLARITY", "GROWTH", "IMPACT", "VISION", "STRATEGY", "CLARITY", "GROWTH", "IMPACT", "VISION"];
  return <section data-section-id="1269" id="final-thought" className="relative bg-white text-black overflow-hidden" style={{
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)"
  }}>
      {}
      <div className="absolute z-10" style={{
      top: "0",
      right: "0"
    }} aria-hidden="true">
        <div className="h-1 w-1 bg-[#E8651A]" />
      </div>

      <div className="relative py-24 md:py-32 px-6 md:px-12">
        {}
        <div ref={eyebrowRef} className={`max-w-[1440px] mx-auto mb-12 md:mb-16 flex items-center gap-3 transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="block h-px w-6 bg-[#E8651A]" />
          <span className="font-default uppercase text-[0.75rem] tracking-[0.25em] text-black/60">
            MD-05
          </span>
        </div>

        {}
        <div className="relative max-w-[1440px] mx-auto">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.03] select-none">
            <span className="font-default leading-none text-black" style={{
            fontSize: "clamp(10rem, 20vw, 20rem)",
            lineHeight: 0.8
          }}>
              05
            </span>
          </div>

          {}
          <h2 ref={headingRef} className={`relative font-default uppercase text-center mx-auto transition-all duration-700 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(2rem, 5vw, 4rem)",
          fontWeight: 500,
          letterSpacing: "0.15em",
          lineHeight: 0.9
        }}>
            READY TO BE{" "}
            <em className="not-italic" style={{
            color: "#E8651A",
            display: "inline-block"
          }}>
              HEARD?
            </em>
          </h2>

          {}
          <p ref={subRef} className={`relative mt-8 md:mt-10 text-center mx-auto max-w-2xl font-default text-black/80 transition-all duration-700 ease-out delay-100 ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
          lineHeight: 1.6,
          letterSpacing: "0.01em"
        }}>
            Your work deserves a voice that cuts through the noise. Let’s build your narrative.
          </p>

          {}
          <div ref={ctaRef} className={`relative mt-12 md:mt-16 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 transition-all duration-700 ease-out delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Link to="/ContactPage" className="block w-full sm:w-auto">
              <Button className="group relative w-full sm:w-auto h-[56px] px-8 bg-[#E8651A] text-white uppercase font-default tracking-[0.15em] text-sm transition-opacity duration-300 hover:opacity-90" style={{
              borderRadius: 0
            }}>
                <span className="relative flex items-center gap-3">
                  START A CONVERSATION
                  <ArrowRight className="size-4" />
                </span>
              </Button>
            </Link>

            <Link to="/ContactPage" className="block w-full sm:w-auto">
              <Button variant="outline" className="w-full sm:w-auto h-[56px] px-8 bg-transparent border border-black text-black hover:bg-black hover:text-white uppercase font-default tracking-[0.15em] text-sm transition-colors duration-300" style={{
              borderRadius: 0
            }}>
                <span className="flex items-center gap-3">
                  <Phone className="size-4" />
                  INQUIRE
                </span>
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative border-t border-b border-[#E5E5E5] py-6 overflow-hidden">
        <div className="flex whitespace-nowrap" style={{
        animation: "ticker-scroll 40s linear infinite"
      }}>
          {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-8 px-8 font-default uppercase text-black/20" style={{
          fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
          letterSpacing: "0.25em",
          lineHeight: 1
        }}>
              <span>{item}</span>
            </div>)}
        </div>
        <style>{`
          @keyframes ticker-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </section>;
}